import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Links from './pages/Links';
import LinkDetail from './pages/LinkDetail';
import Users from './pages/Users';
import Archives from './pages/Archives';
import Settings from './pages/Settings';
import Monitor from './pages/Monitor';
import { useEffect, useState } from 'react';
import api from './utils/api';

function ShortLinkRedirect() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const code = window.location.pathname.slice(1); // Remove leading /
    if (!code) {
      navigate('/s/dashboard');
      return;
    }
    // Try to resolve short link
    api.get(`resolve/${code}`).json<{ success: boolean; data?: { target_url: string } }>().then((res) => {
      if (res.success && res.data?.target_url) {
        window.location.href = res.data.target_url;
      } else {
        navigate('/s/dashboard');
      }
    }).catch(() => {
      navigate('/s/dashboard');
    }).finally(() => {
      setChecking(false);
    });
  }, [navigate]);

  if (checking) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>正在跳转...</div>;
  }
  return null;
}

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/s"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/s/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="links" element={<Links />} />
        <Route path="links/:id" element={<LinkDetail />} />
        <Route path="users" element={<Users />} />
        <Route path="archives" element={<Archives />} />
        <Route path="settings" element={<Settings />} />
        <Route path="monitor" element={<Monitor />} />
      </Route>
      <Route path="*" element={<ShortLinkRedirect />} />
    </Routes>
  );
}

export default App;
